import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { ApiRequestOptions } from './core/ApiRequestOptions';
import { BaseHttpRequest } from './core/BaseHttpRequest';
import { CancelablePromise } from './core/CancelablePromise';
import type { OpenAPIConfig } from './core/OpenAPI';
import { request as __request } from './core/request';
import { emitter } from 'App';
export class WrapperClient extends BaseHttpRequest {
  axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BRANCH,
    timeout: 60000,
  });

  constructor(config: OpenAPIConfig) {
    super(config);

    // Get the access token from secure storage and add it to the request headers.
    this.axiosInstance.interceptors.request.use(
      async (requestConfig: AxiosRequestConfig) => {
        const accessToken = localStorage.getItem('jwt') as string;

        // Check if headers exist, if not, initialize them
        if (!requestConfig.headers) {
          requestConfig.headers = {};
        }

        requestConfig.headers.authorization = accessToken;

        return requestConfig;
      },
      (error) => {

        return Promise.reject(error);
      }
    );

    // Add a response interceptor for unauthenticated tokens.
    this.axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response && (error.response.status === 502 || error.response.status === 503)) {
          emitter.emit('maintenance');
    
          // You can add a delay if necessary to allow time for the event to propagate.
          return new Promise((_, reject) => {
            setTimeout(() => {
              reject(error);  // This will reject the promise after the emitter has done its work
            }, 0);  // Adjust the delay if needed
          });
        }
    
        return Promise.reject(error);  // For other errors
      }
    );
  }

  public override request<T>(options: ApiRequestOptions): CancelablePromise<T> {
    return __request(this.config, options, this.axiosInstance);
  }
}
